/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { InstanceTile } from './InstanceTile.js';
import styled from 'styled-components';

const InstancesPanelBody = styled.div`
  display: flex;
  flex-wrap: wrap;

  padding: 0 1.25rem;

  @media (min-width: 768px) {
    padding: 0 0 0 1rem;
  }
`;

const StyledSpan = styled.span`
  position: relative;
  float: left;

  :hover {
    text-decoration: none;
  }

  @media (min-width: 768px) {
    width: 20rem;
  }

  @media (max-width: 767px) {
    width: 100%;
    margin-right: 0rem;
  }
`;

const Filler = styled.div`
  flex: 1 1 auto;
  max-width: 318px;
  min-width: 220px;
  margin-right: 1rem;
`;

export default class StatusGridView extends React.Component {
  static propTypes = {
    onInstanceClicked: PropTypes.func,
    instanceGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
  };

  render() {
    const { instanceGroups, onInstanceClicked } = this.props;

    // row filler, fills empty rows
    const filler = _.range(12).map((i) => (
      <Filler key={i}></Filler>
    ));

    instanceGroups.sort((a, b) => a.key - b.key);

    return (
      <InstancesPanelBody>
        { instanceGroups.map((instance) => (
          <StyledSpan key={instance.key} onClick={() => onInstanceClicked()}>
            <InstanceTile
              instance={ instance }
              displayText={ instance.alias ? (instance.alias.toUpperCase() + ' | ' + instance.key) : instance.key }
            />
          </StyledSpan>
        ))}
        {filler}
      </InstancesPanelBody>
    );
  }
}
